// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingInvoiceItemPaymentResponse

import { PaymentObjectType } from './enums.gen';
import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type BillingInvoiceItemPaymentApiResponse = {
	id: string;
	date: string;
	amount: number;
	feePercent: number;
	feeFixed: number;
	feeHt: number;
	splitFeeTtc: number;
	splitFeeHt: number;
	totalFeeHt: number;
	totalFeeTtc: number;
	type: PaymentObjectType | null;
	bookingId: string | null;
	customerName: string | null;
	customerFirstname: string | null;
	customerLastname: string | null;
	customerEmail: string | null;
	bookingDate: string | null;
	bookingPax: number | null;
	bookingOffers: string | null;
};

export type BillingInvoiceItemPayment = {
	id: string;
	date: DateTime;
	amount: number;
	feePercent: number;
	feeFixed: number;
	feeHt: number;
	splitFeeTtc: number;
	splitFeeHt: number;
	totalFeeHt: number;
	totalFeeTtc: number;
	type: PaymentObjectType | null;
	bookingId: string | null;
	customerName: string | null;
	customerFirstname: string | null;
	customerLastname: string | null;
	customerEmail: string | null;
	bookingDate: DateTime | null;
	bookingPax: number | null;
	bookingOffers: string | null;
};

export function hydrateBillingInvoiceItemPayment(data: BillingInvoiceItemPaymentApiResponse): BillingInvoiceItemPayment {
	return {
		...data,
		date: DateTimefromISO(data.date)!,
		bookingDate: DateTimefromYmd(data.bookingDate),
	};
}